//
// Group box-like input widget with title.
//
import { useState } from 'react';

import gUtilities from '../script/utilities';

const k_int_expression = "^[0-9]+$";
const k_float_expression = "^[+-]?[0-9]+([.][0-9]+)?([eE][+-]?[0-9]+)?$";
const k_time_span_expression = "^([0-9]+)\\s*([msh]+)$";

//
// props:
//   string    title      - header for text
//   string    text       - characters to show in <input>
//   string    type       - [optional] one of { string, int, float, time-span }
//   string    width      - one of { small, medium, large, 'Npx' }
//   function  onChange   - [optional] function(text) -> void 
//
const TextWidget = (props) => {
    const [widgetID] = useState(gUtilities.widgetID());

    function isReadonly() {
        if (props.hasOwnProperty("onChange")) {
            return false;
        }

        return true;
    }

    function textStyle() {
        let px = "200px";

        if (props.hasOwnProperty("width")) {
            if (props.width === "small") {
                px = "120px";
            } else if (props.width === "large") {
                px = "300px";
            } else {
                px = props.width;
            }
        }
        
        let style = {
            width: px
        };

        return style;
    }

    function getValue() {
        let widget = document.querySelector("#" + widgetID);
        
        return widget.value;
    }

    function setValue(value) {
        let widget = document.querySelector("#" + widgetID);
        
        return widget.value = value;
    }

    function onChange() {
        let value = getValue();
        let update = true;

        if (props.hasOwnProperty("type")) {
            if (props.type === "int") {
                if (value.match(k_int_expression)) {
                    value = parseInt(value);
                } else {
                    gUtilities.showError(props.title, `Value '${value}' is not an integer`);
                    setValue(props.text);
                    update = false;
                }
            } else if (props.type === "float") {
                if (value.match(k_float_expression)) {
                    value = parseFloat(value);
                } else {
                    gUtilities.showError(props.title, `Value '${value}' is not a valid floating point number`);
                    setValue(props.text);
                    update = false;
                }
            } else if (props.type === "time-span") {
                if (value.match(k_time_span_expression)) {
                    let groups = value.match(k_time_span_expression);
                    let units = groups[2];
                    let num = parseInt(groups[1]);

                    if (units === "ms") {
                        value = num;
                    } else if (units === "s") {
                        value = 1000 * num;
                    } else if (units === "m") {
                        value = 60 * 1000 * num
                    } else if (units === "h") {
                        value = 60 * 60 * 1000 * num                        
                    } else {
                        gUtilities.showError(props.title, `Value '${value}' is not a valid time span (units {ms, s, m, h})`);
                        setValue(props.text);
                        update = false;
                    }
                } else {
                    gUtilities.showError(props.title, `Value '${value}' is not a valid time span`);
                    setValue(props.text);
                    update = false;
                }
            } else {
                    gUtilities.showError(props.title, `WARNING: Unknown data type ${props.type}`);
            }
        }

        if (update) {
            props.onChange(value);
        }
    }

    return (
        <div className="form-group">
            <label className="col-form-label mt-1" htmlFor={widgetID}>{props.title}</label>
            <div className="input-group mb-1">
                { isReadonly() && 
                    <input type="text" className="form-control" id={widgetID} name={widgetID} value={props.text ?? ""} readOnly={true} onChange={() => {}} style={textStyle()}></input>
                }
                { !isReadonly() && 
                    <input type="text" className="form-control" id={widgetID} name={widgetID} placeholder={props.text} style={textStyle()} onBlur={() => onChange()}></input>
                }
            </div>
        </div>
    );
}

export default TextWidget;
